<template>
  <div>
    <label class="section-title -mt-large -mb">Setters:</label>
    <div v-for="(setter, index) in editableSetters" :key="index" class="halves">
      <!--
      --><input v-model="setter.field" type="text" placeholder="Field" @input="change" /><!--
      --><input v-model="setter.value" type="text" placeholder="Value" @input="change" />
      <span v-if="setterError(index, 'field')" class="alert -inline -danger"
        >Setter field {{ setterError(index, "field") }}</span
      >
      <span v-if="setterError(index, 'value')" class="alert -inline -danger"
        >Setter value {{ setterError(index, "value") }}</span
      >
      <a href="#" class="button -danger -small" @click.prevent="removeSetter(setter)">Remove this setter</a>

      <hr />
    </div>

    <a href="#" class="button -small -mb" @click.prevent="addSetter">Add a setter</a>
  </div>
</template>

<script>
import dig from "object-dig";
import _ from "underscore";

export default {
  name: "QuerySetters",

  props: {
    query: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    errors: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      editableSetters: [],
      editableErrors: []
    };
  },

  watch: {
    query(newQuery, oldQuery) {
      // Only reset if loading different query (by ID change)
      if (!oldQuery || oldQuery.id !== newQuery.id) {
        this.setEditableSetters();
      }
    },

    errors() {
      this.editableErrors = this.errors;
    }
  },

  mounted() {
    this.setEditableSetters();
  },

  methods: {
    setterError(index, attr) {
      return dig(this.editableErrors, this.type, "setters", index, attr, 0);
    },

    addSetter() {
      this.editableSetters.push({ field: "", value: "" });
      this.change();
    },

    removeSetter(setter) {
      this.editableSetters = _.without(this.editableSetters, setter);
      this.change();
    },

    change() {
      this.editableErrors = {};
      this.$emit("change", this.editableSetters);
    },

    setEditableSetters() {
      this.editableSetters = dig(this.query, this.type, "setters");
    }
  }
};
</script>
